module.exports = __webpack_public_path__ + "static/img/03.699f7df.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/03.jpg
// module id = 1Ln8
// module chunks = 18